import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { VisitedStepsState } from './visitedSteps.types';

import { StepName } from '~/core/enums';
import { takeAllBefore } from '~/core/utils/misc.utils';
import { allSteps } from '~/redux/slices/stepper/stepper.machine';
import { compareSteps } from '~/redux/slices/stepper/stepper.utils';

const initialState: VisitedStepsState = {
  visitedSteps: [],
};

const visitedStepsSlice = createSlice({
  name: 'visitedSteps',
  initialState,

  reducers: {
    updateVisitedSteps: (
      state: VisitedStepsState,
      action: PayloadAction<StepName>
    ) => {
      if (!state.visitedSteps.includes(action.payload)) {
        state.visitedSteps = [...state.visitedSteps, action.payload].sort(
          compareSteps
        );
      }
    },
    visitAllSteps: (state: VisitedStepsState) => {
      state.visitedSteps = allSteps;
    },
    resetVisitedSteps: (
      state: VisitedStepsState,
      { payload: step }: PayloadAction<StepName>
    ) => {
      state.visitedSteps = takeAllBefore(state.visitedSteps, step);
    },
  },
});

export const { updateVisitedSteps, resetVisitedSteps, visitAllSteps } =
  visitedStepsSlice.actions;

export default visitedStepsSlice.reducer;
